<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'">
            © {{ new Date().getFullYear() }}, made with
            <i class="fa fa-heart" aria-hidden="true"></i> by
            <a href="https://adam-ai.com/" class="font-weight-bold" target="_blank" rel="noopener">ADAM GMBH</a>
            
          </div>
        </div>
        <div class="col-lg-6">
          <ul class="nav nav-footer justify-content-center justify-content-lg-end">
            <li class="nav-item">
              <span class="nav-link text-muted">fon +49 541 6001544</span>
            </li>
            <li class="nav-item">
              <span class="nav-link text-muted">fax +49 541 6001559</span>
            </li>
            <li class="nav-item">
              <span class="nav-link text-muted">mail hallo@adam-ki.de</span>
            </li>
            <li class="nav-item">
              <a href="https://adam-ai.com/impressum/" class="nav-link text-muted" target="_blank" rel="noopener">Impressum</a>
            </li>
            <li class="nav-item">
              <a href="https://adam-ai.com/datenschutz/" class="nav-link text-muted" target="_blank" rel="noopener">Datenschutz</a>
            </li>
            <li class="nav-item">
              <a href="https://adam-ai.com/agb/" class="nav-link text-muted" target="_blank" rel="noopener">AGB</a>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
